const flatAndHouseRentFilters = [
  // «Что нужно в квартире/доме»
  'has_furniture',
  'has_fridge',
  'has_washer',
  'has_kitchen_furniture',
  'internet',
  'tv',
  'conditioner',
  'dish_washer',
  'phone',
  'kids',
  'pets',
  'bath',
  'shower',

  'composition',
];

const filtersForRoom = [
  'room_area',
  'rooms_for_sale',
  'rooms_count',
];

const filtersForHouse = [
  'total_area',
  'bathhouse',
  'bedroom_total',
  'floorn',
  'garage',
  'heating_source_type',
  'house_material',
  'house_year',
  'pool',
  'repair',
  'wc_site',
];

export const flat = {
  _common: [
    'room', // Комнатность + комната/доля

    'floor',
    'floorn',
    'is_first_floor',
    'not_last_floor',

    'lift_passanger',
    'lifts',
    'lift_service',

    // до метро
    'only_foot',
    'foot_min',

    // площади
    'total_area',
    'kitchen',

    'is_by_homeowner',

    'house_material',
    'house_year',
    'ceiling_height',
    'wc',
    'wc_type',
    'windows_type',
    'parking_type',
    'repair',
    'loggia',
    'balconies',
    'minbalkon',
  ],
  sale: [
    'price_sm',
    'ipoteka',
    'sost_type'
  ],
  rentLong: [
    ...flatAndHouseRentFilters,
    'prepay',
    'zalog',
  ],
  rentShort: [
    ...flatAndHouseRentFilters,
  ],

  flat: [
    'living_area',
  ],
  flatShare: [
    'living_area',
    'rooms_count',
  ],
  room: filtersForRoom,
  bed: filtersForRoom,
};

export const suburban = {
  _common: [
    'object_type',
    'site',
    'is_by_homeowner',
    'electricity',
    'gas',
    'has_drainage',
    'has_water',
  ],
  rentLong: [
    ...flatAndHouseRentFilters,
    'prepay',
    'zalog',
  ],
  rentShort: [
    ...flatAndHouseRentFilters,
  ],
  house: filtersForHouse,
  houseShare: filtersForHouse,
  townhouse: filtersForHouse,
  land: [
    'land_status',
  ],
}



// WEBPACK FOOTER //
// ./src/serp/services/available-filters/available-filters.living.js